<script setup lang="ts">
    import { Tabs } from '@/components/ui/tabs';
    import { useFormErrorTabs } from '@/composables/useFormErrorTabs';
    import RoleGeneralForm from '@/components/roles/RoleGeneralForm.vue';
    import RolePermissionsForm from '@/components/roles/RolePermissionsForm.vue';

    const props = defineProps<{
        form: any;
    }>();

    const tabs = [
        { value: 'general', label: 'roles.general_tab_text' },
        { value: 'permissions', label: 'roles.permissions_tab_text' },
    ];

    const fieldToTabMap = {
        name: 'general',
        display_name: 'general',
        description: 'general',

        permission_ids: 'permissions',
    };

    const { currentTab } = useFormErrorTabs(props.form, fieldToTabMap, 'general');
</script>

<template>
    <Tabs
        :tabs="tabs"
        v-model="currentTab"
    >
        <template #general>
            <RoleGeneralForm :form="form" />
        </template>
        <template #permissions>
            <RolePermissionsForm :form="form" />
        </template>
    </Tabs>
</template>
